(function () {
  var TOAST_MS = 2600;

  class SingleEarbudPurchase extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.overlay = this.querySelector('.single-earbud-purchase__overlay');
      this.dialog = this.querySelector('.single-earbud-purchase__dialog');
      this.toast = this.querySelector('.shokz-toast');
      this.toastText = this.querySelector('.shokz-toast__text');
      this.openBtn = this.querySelector('[data-action="open"]');
      this.closeBtn = this.querySelector('[data-action="close"]');
      this.emailBtn = this.querySelector('[data-action="copy-email"]');
      this.supportEmail =
        this.dataset.supportEmail || 'support.uk@shokz.com';
      this.toastMessage =
        this.dataset.toastMessage || 'Customer support email copied';
      this._scrollY = 0;

      this._bindEvents();
      this._portalToBody();

      this._onKeydown = this._onKeydown.bind(this);
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
      this._unlockScroll();
    }

    _bindEvents() {
      var self = this;

      if (this.openBtn) {
        this.openBtn.addEventListener('click', function (event) {
          event.preventDefault();
          self._openDialog();
        });
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          self._closeDialog();
        });
      }

      if (this.emailBtn) {
        this.emailBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          self._copyEmail();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', function (event) {
          if (event.target === self.overlay) {
            self._closeDialog();
          }
        });
      }

      if (this.dialog) {
        this.dialog.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    }

    _portalToBody() {
      if (!document.body) return;

      if (this.overlay && this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }
      if (this.toast && this.toast.parentElement !== document.body) {
        document.body.appendChild(this.toast);
      }
    }

    _onKeydown(event) {
      if (event.key !== 'Escape' || !this.overlay || this.overlay.hidden) return;
      this._closeDialog();
    }

    _openDialog() {
      if (!this.overlay) return;
      this._portalToBody();
      this._lockScroll();
      this.overlay.hidden = false;
      requestAnimationFrame(() => {
        if (this.dialog) this.dialog.focus();
      });
    }

    _closeDialog() {
      if (!this.overlay) return;
      this.overlay.hidden = true;
      document.documentElement.classList.remove('single-earbud-purchase-open');
      this._unlockScroll();
    }

    _lockScroll() {
      this._scrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('single-earbud-purchase-open');
      document.body.classList.add('single-earbud-purchase-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this._scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    _unlockScroll() {
      document.documentElement.classList.remove('single-earbud-purchase-open');
      document.body.classList.remove('single-earbud-purchase-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, this._scrollY || 0);
    }

    _copyEmail() {
      var email = this.supportEmail;
      var self = this;
      var showCopied = function () {
        self._showToast(self.toastMessage);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(showCopied).catch(showCopied);
        return;
      }

      try {
        var input = document.createElement('textarea');
        input.value = email;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        showCopied();
      } catch (err) {
        showCopied();
      }
    }

    _showToast(message) {
      if (!this.toast) return;
      this._portalToBody();
      if (this.toastText) {
        this.toastText.textContent = message;
      }
      this.toast.hidden = false;
      this.toast.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      var self = this;
      this._toastTimer = setTimeout(function () {
        self.toast.classList.remove('is-visible');
        self.toast.hidden = true;
      }, TOAST_MS);
    }
  }

  if (!customElements.get('single-earbud-purchase')) {
    customElements.define('single-earbud-purchase', SingleEarbudPurchase);
  }
})();
